import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import {purpose, resetResponse} from '../Redux/Slice/rootSlice';
import {createCouplePatientsRecord} from '../Redux/Thunk/Actions';
import '../styles/Components/AddPatient_form.scss';

function AddPatientCouple_form(props) {
  const purpose1 = useSelector(state => state.counter.purpose);
  const patientData = useSelector(state => state.counter.patientsData);

  console.log(`patientData -->`, patientData);
  const [createUserInfo, setCreateUserInfo] = useState([
    {
      last_name: '',
      first_name: '',
      email: '',
      phonenumber: '',
      gender: 'Male',
      birthdate: null,
      age: '0',
      // blood_group: "",
      titles: 'Mr',
      purpose: purpose1,
      residence: ''
      // doctor_id: "",
    },
    {
      last_name: '',
      first_name: '',
      email: '',
      phonenumber: '',
      gender: 'Female',
      birthdate: null,
      age: '0',
      // blood_group: "",
      titles: 'Mrs',
      purpose: purpose1,
      residence: ''
      // doctor_id: "",
    }
  ]);
  const [alert, setAlert] = useState(false);
  const [cplFill1, setCplFill1] = useState(false);
  const [cplFill2, setCplFill2] = useState(false);
  const [patient1, setPatient1] = useState(true);
  const [patient2, setPatient2] = useState(false);
  const [error, setError] = useState(false);
  const [specificError, setSpecificError] = useState([]);
  const [docref, setdocref] = useState(['Source Google', 'Instagram', 'Facebook', 'YouTube', 'Friends', 'Neighbour', 'Relatives', 'Doctor', 'Existing Patient', 'Others']);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [doctorid, setdoctorid] = useState('');
  const areAllUserInfo1Valid = Object.keys(createUserInfo[0])
    .filter(key => key !== 'email' && key !== 'gender' && key !== 'birthdate' && key !== 'age' && key !== 'blood_group' && key !== 'doctor_id' && key !== 'residence')
    .every(key => createUserInfo[0][key] !== '');
  const areAllUserInfo2Valid = Object.keys(createUserInfo[1])
    .filter(key => key !== 'email' && key !== 'gender' && key !== 'birthdate' && key !== 'age' && key !== 'blood_group' && key !== 'doctor_id' && key !== 'residence')
    .every(key => createUserInfo[1][key] !== '');

  useEffect(() => {
    const data = Array.isArray(patientData) ? patientData[0]?.data : patientData?.data;

    if (data) {
      setAlert(true);
      if (Array.isArray(data) && data.length >= 2) {
        const patient1 = {...{purpose: purpose1}, ...data[0]};
        const patient2 = {...{purpose: purpose1}, ...data[1]};
        setCreateUserInfo([patient1, patient2]);
        setdoctorid(data[0].doctor_id || '');
      } else {
        const firstPatientData = Array.isArray(data) ? data[0] : data;
        if (firstPatientData) {
          const firstPatient = {...{purpose: purpose1}, ...firstPatientData};
          const oppositeGender = firstPatient.gender === 'Male' ? 'Female' : 'Male';
          const oppositeTitle = oppositeGender === 'Male' ? 'Mr' : 'Mrs';
          setCreateUserInfo([
            firstPatient,
            {
              last_name: '',
              first_name: '',
              email: '',
              phonenumber: '',
              gender: oppositeGender,
              birthdate: null,
              age: '0',
              titles: oppositeTitle,
              purpose: firstPatient.purpose
            }
          ]);
          setdoctorid(firstPatient.doctor_id || '');
        }
      }
    }
  }, [patientData]);

  useEffect(() => {
    if (createUserInfo[0].purpose === 'Fertility') {
      setCreateUserInfo(prev => [
        {...prev[0], gender: prev[0].gender, titles: prev[0].titles},
        {...prev[1], gender: prev[1].gender, titles: prev[1].titles}
      ]);
    } else {
      setCreateUserInfo(prev => [
        {...prev[0], gender: 'Male', titles: 'Mr'},
        {...prev[1], gender: 'Female', titles: 'Mrs'}
      ]);
    }
  }, [createUserInfo[0].purpose]);

  const closeUserPopup = e => {
    if (alert) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, revert it!'
      }).then(result => {
        if (result.isConfirmed) {
          navigate('/Patients');
          setAlert(false);
          props.setCoupleCreatePopUp(false);
        }
      });
    } else {
      navigate('/Patients');
      setAlert(false);
      props.setCoupleCreatePopUp(false);
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
  };

  const handleBirthDateChange1 = e => {
    const date = e.target.value;
    if (date) {
      const birthDate = new Date(date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setCreateUserInfo([
        {
          ...createUserInfo[0],
          birthdate: date,
          age: age.toString()
        },
        ...createUserInfo.slice(1)
      ]);
    } else {
      setCreateUserInfo([
        {
          ...createUserInfo[0],
          birthdate: null,
          age: ''
        },
        ...createUserInfo.slice(1)
      ]);
    }
  };

  const handleBirthDateChange2 = e => {
    const date = e.target.value;
    if (date) {
      const birthDate = new Date(date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setCreateUserInfo([
        createUserInfo[0],
        {
          ...createUserInfo[1],
          birthdate: date,
          age: age.toString()
        }
      ]);
    } else {
      setCreateUserInfo([
        createUserInfo[0],
        {
          ...createUserInfo[1],
          birthdate: null,
          age: ''
        }
      ]);
    }
  };

  const handleDropChanges = e => {
    const {name, value} = e.target;
    setAlert(true);

    if (name === 'purpose') {
      dispatch(purpose(value));
      setCreateUserInfo(prev => prev.map(p => ({...p, purpose: value})));
      if (value !== 'Fertility') {
        if (props.setCoupleCreatePopUp) {
          props.setCoupleCreatePopUp(false);
          props.setCloseCreatePopup(true);
        }
      }
    } else if (name === 'gender') {
      const newTitle = value === 'Male' ? 'Mr' : 'Mrs';
      const oppositeGender = value === 'Male' ? 'Female' : 'Male';
      const oppositeTitle = oppositeGender === 'Male' ? 'Mr' : 'Mrs';
      setCreateUserInfo(prev => [
        {...prev[0], gender: value, titles: newTitle},
        {...prev[1], gender: oppositeGender, titles: oppositeTitle}
      ]);
    } else if (name === 'titles') {
      const newGender = value === 'Mr' ? 'Male' : 'Female';
      setCreateUserInfo(prev => [{...prev[0], titles: value, gender: newGender}, prev[1]]);
    } else {
      setCreateUserInfo(prev => [{...prev[0], [name]: value}, prev[1]]);
    }
  };
  // *------------------------
  const handleDropChanges2 = e => {
    const {name, value} = e.target;
    setAlert(true);

    if (name === 'gender') {
      const newTitle = value === 'Male' ? 'Mr' : 'Mrs';
      setCreateUserInfo(prev => [prev[0], {...prev[1], gender: value, titles: newTitle}]);
    } else if (name === 'titles') {
      const newGender = value === 'Mr' ? 'Male' : 'Female';
      setCreateUserInfo(prev => [prev[0], {...prev[1], titles: value, gender: newGender}]);
    } else {
      setCreateUserInfo(prev => [prev[0], {...prev[1], [name]: value}]);
    }
  };

  const handleNameChange = e => {
    setAlert(true);
    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo([
        {
          ...createUserInfo[0],
          [e.target.name]: e.target.value.toUpperCase()
        },
        ...createUserInfo.slice(1)
      ]);
    }
  };
  // *------------------------
  const handleNameChange2 = e => {
    setAlert(true);
    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo([
        createUserInfo[0],
        {
          ...createUserInfo[1],
          [e.target.name]: e.target.value.toUpperCase()
        }
      ]);
    }
  };

  const handleEmailChange = e => {
    setAlert(true);

    setCreateUserInfo([
      {
        ...createUserInfo[0],
        email: e.target.value
      },
      ...createUserInfo.slice(1)
    ]);
  };
  // *------------------------
  const handleEmailChange2 = e => {
    setAlert(true);

    setCreateUserInfo([
      createUserInfo[0],
      {
        ...createUserInfo[1],
        email: e.target.value
      }
    ]);
  };

  const handleAgeChange = e => {
    setAlert(true);
    if ((e.target.value === '' || !e.target.value.includes(' ')) && e.target.value.length <= 2) {
      setCreateUserInfo([
        {
          ...createUserInfo[0],
          age: e.target.value
        },
        ...createUserInfo.slice(1)
      ]);
    }
  };
  // *------------------------
  const handleAgeChange2 = e => {
    setAlert(true);
    if ((e.target.value === '' || !e.target.value.includes(' ')) && e.target.value.length <= 2) {
      setCreateUserInfo([
        createUserInfo[0],
        {
          ...createUserInfo[1],
          age: e.target.value
        }
      ]);
    }
  };

  const handleMobileChange = e => {
    setAlert(true);

    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo([
        {
          ...createUserInfo[0],
          phonenumber: e.target.value
        },
        ...createUserInfo.slice(1)
      ]);
    }
    if (e.target.value.length > 10) {
      setSpecificError({
        ...specificError,
        mobileSpecificError: true
      });
    } else {
      setSpecificError({
        ...specificError,
        mobileSpecificError: false
      });
    }
  };

  // *------------------------
  const handleMobileChange2 = e => {
    setAlert(true);

    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setCreateUserInfo([
        createUserInfo[0],
        {
          ...createUserInfo[1],
          phonenumber: e.target.value
        }
      ]);
    }
    if (e.target.value.length > 10) {
      setSpecificError({
        ...specificError,
        mobileSpecificError: true
      });
    } else {
      setSpecificError({
        ...specificError,
        mobileSpecificError: false
      });
    }
  };

  const handleDocIdChange = e => {
    setAlert(true);
    if (e.target.value === '' || !e.target.value.includes(' ')) {
      setdoctorid(e.target.value);
      setCreateUserInfo([
        {
          ...createUserInfo[0],
          doctor_id: e.target.value
        },
        {
          ...createUserInfo[1],
          doctor_id: e.target.value
        }
      ]);
    }
  };

  const handleCreatePatient1 = () => {
    console.log(createUserInfo);
    const CreateThunk = () => {
      setPatient1(false);
      setPatient2(true);
      setCplFill1(true);
    };
    // console.log(areAllUserInfoValid)
    if (areAllUserInfo1Valid) {
      setError(false); //*to avoid the error field in the second patient
      CreateThunk();
    } else {
      setError(true);
    }
  };

  const handleCreatePatient2 = () => {
    props.loaderchange('true');

    const cleanedUserInfo = createUserInfo.map(p => {
      if (p.data) {
        const {data, ...rest} = p;
        return rest;
      }
      return p;
    });

    const postCoupleData = async () => {
      props.loaderchange(true);
      const firstPatientId = Array.isArray(patientData) ? patientData[0]?.data?.id : patientData?.data?.id;

      console.log(`firstPatientId -->`, firstPatientId);

      const addPatient = createCouplePatientsRecord({userData: cleanedUserInfo, patientId: firstPatientId});
      const response = await dispatch(addPatient);
      if (response?.payload?.status?.code === 200) {
        props.setCoupleCreatePopUp(false);
        props.setUpdate(true);
        props.loaderchange(false);
        dispatch(resetResponse(''));
        Swal.fire({
          title: 'Successful.',
          text: 'Record added successful.',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500
        });
        props.loaderchange('false');
      } else {
        props.loaderchange('false');
        props.popupalert('true');
        props.popuptext('Network went wrong, Please try after some time.');
        setTimeout(() => {
          props.popupalert('false');
        }, 2000);
        dispatch(resetResponse(''));
      }
    };
    if (areAllUserInfo2Valid) {
      postCoupleData();
    } else {
      setError(true);
    }
  };

  const today = new Date();

  return (
    <>
      <div className='adminform'>
        <div class='modal-dialog1' role='document'>
          <div class='modal-content modelContentChanges'>
            <div class='modal-header'>
              <h5 class='modal-title'>Create Couple Patient Record</h5>
              <button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={e => closeUserPopup(e)}>
                <i class='bi bi-x-lg'></i>
              </button>
            </div>

            {/* //*this is for the first couple */}
            {patient1 && (
              <>
                <div>
                  <span class={`btn btn-secondary btn-sm ${cplFill1 ? 'cplBtn' : ''}`} style={{}}>
                    Patient 1
                  </span>
                </div>
                <div class='modal-body modelBodyChanges' style={{padding: '1rem', width: '920px'}}>
                  <form onSubmit={handleSubmit}>
                    <div class='row'>
                      <div class='col-3 title-dropdown'>
                        <label for='validationCustom01' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Title
                        </label>
                        <select
                          id='titles'
                          name='titles'
                          value={createUserInfo[0].titles}
                          disabled={createUserInfo[0].purpose !== 'Fertility'}
                          onChange={e => handleDropChanges(e)}
                          className='form-select'>
                          <option value='' disabled selected>
                            Select a Title
                          </option>
                          <option value='Mr'>Mr</option>
                          <option value='Mrs'>Mrs</option>
                          <option value='Miss'>Miss</option>
                        </select>

                        {error && createUserInfo[0].titles == '' && (
                          <p style={{fontSize: '12px', color: 'red'}}>
                            <span>Required Title</span>
                          </p>
                        )}
                      </div>
                      <div class='col-3 title-dropdown'>
                        <label for='purpose' class='form-label'>
                          Purpose
                        </label>
                        <select id='purpose' name='purpose' value={createUserInfo[0].purpose} onChange={e => handleDropChanges(e)} className='form-select'>
                          <option value='' disabled selected>
                            Select Purpose
                          </option>
                          <option value='General'>General</option>
                          <option value='AN'>AN</option>
                          <option value='Fertility'>Fertility</option>
                          <option value='Gynecology'>Gynecology</option>
                        </select>
                      </div>
                    </div>
                    <div class='row'>
                      <div class='col mt-3'>
                        <label for='validationCustom01' class='form-label'>
                          <span style={{color: 'red'}}>*</span>First Name
                        </label>
                        <input
                          type='text'
                          class='form-control inputStyleChange f_name'
                          id='validationCustom01'
                          name='first_name'
                          variant='standard'
                          style={{textTransform: 'uppercase'}}
                          autoComplete='off'
                          value={createUserInfo[0].first_name}
                          onKeyDown={e => {
                            if (e.target.value.length === 0 && e.which === 32) {
                              e.preventDefault();
                            }
                          }}
                          onChange={e => handleNameChange(e)}
                          placeholder='Enter Patient First Name....'></input>
                        <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo[0].first_name === '' && <span>Required First Name</span>}</p>
                      </div>

                      <div class='col mt-3'>
                        <label for='validationCustom02' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Last Name
                        </label>
                        <input
                          type='text'
                          class='form-control inputStyleChange l_name'
                          id='validationCustom02 '
                          name='last_name'
                          style={{textTransform: 'uppercase'}}
                          autoComplete='off'
                          onChange={e => handleNameChange(e)}
                          // onBlur={handleLastNameBlur}
                          onKeyDown={e => {
                            if (e.which == '32') {
                              e.preventDefault();
                            }
                          }}
                          value={createUserInfo[0].last_name}
                          placeholder='Enter Patient Last Name....'></input>
                        <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo[0].last_name == '' && <span>Required Last Name</span>}</p>
                      </div>
                    </div>
                    <div class='row'>
                      <div class='col mt-3'>
                        <label for='validationCustomUsername' class='form-label'>
                          Email
                        </label>
                        <div class='input-group has-validation'>
                          <span
                            class='input-group-text mailIcon inputStyleChange'
                            id='inputGroupPrepend'
                            style={{
                              borderRadius: '6px 0px 0px 6px'
                            }}>
                            @
                          </span>
                          <input
                            type='text'
                            class='form-control inputStyleChange'
                            id='email1'
                            aria-describedby='inputGroupPrepend'
                            autoComplete='off'
                            value={createUserInfo[0].email}
                            name='email'
                            onChange={e => handleEmailChange(e)}
                            placeholder='Enter Patient Mail id....'
                            // onBlur={handleEmailBlur}
                          ></input>
                        </div>
                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.email == "" && (
                        <span>Required Email</span>
                      )}
                    </p> */}
                      </div>
                      <div class='col mt-3'>
                        <label for='validationCustom02' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Whatsapp Mobile Number
                        </label>
                        <input
                          type='phonenumber'
                          class='form-control inputStyleChange'
                          id='validationCustom02 '
                          name='phonenumber'
                          autoComplete='off'
                          maxLength={10}
                          onChange={e => handleMobileChange(e)}
                          // onBlur={handleMobileBlur}
                          onKeyDown={e => {
                            if (e.which == '32') {
                              e.preventDefault();
                            }
                          }}
                          value={createUserInfo[0].phonenumber}
                          placeholder='Enter Patient Mobile Number....'></input>
                        <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo[0].phonenumber == '' && <span>Required Phone number</span>}</p>
                        {specificError.mobileSpecificError && (
                          <p style={{fontSize: '12px', color: 'red'}}>
                            <span>Enter Valid Phone Number.</span>
                          </p>
                        )}
                      </div>
                    </div>
                    <div class='row'>
                      <div className=' mt-4 col'>
                        <label for='validationCustom01' class='form-label'>
                          Gender
                        </label>
                        <select
                          id='titles'
                          name='gender'
                          value={createUserInfo[0].gender}
                          disabled={createUserInfo[0].purpose !== 'Fertility'}
                          onChange={handleDropChanges}
                          className='form-select inputStyleChange'>
                          <option value='' disabled selected>
                            Select a Gender
                          </option>
                          <option value='Male'>Male</option>
                          <option value='Female'>Female</option>
                          <option value='Other'>Other</option>
                          <option value='Decline to State'>Decline to State</option>
                        </select>
                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.gender == "" && (
                        <span>Required Gender</span>
                      )}
                    </p> */}
                      </div>
                      <div class='col mt-4'>
                        <label for='dob1' class='form-label'>
                          Date of Birth
                        </label>
                        <input
                          type='date'
                          name='birthdate'
                          onChange={handleBirthDateChange1}
                          value={createUserInfo[0].birthdate || ''}
                          className='form-control inputStyleChange'
                          id='dob1'
                          autoComplete='off'
                          max={today.toISOString().split('T')[0]}
                        />
                      </div>
                      <div class='col mt-4'>
                        <label for='validationCustom02' class='form-label'>
                          Age
                        </label>
                        <input
                          type='number'
                          class='form-control inputStyleChange'
                          id='validationCustom02 '
                          name='age'
                          autoComplete='off'
                          maxLength={2}
                          onChange={e => handleAgeChange(e)}
                          readOnly
                          // onBlur={handleMobileBlur}
                          onKeyDown={e => {
                            if (e.which == '32') {
                              e.preventDefault();
                            }
                          }}
                          value={createUserInfo[0].age}></input>

                        {/* <DatePicker
                      type="date"
                      name="birthdate"
                      format="dd MM yyyy"
                      onChange={handleBirthDateChanges}
                      class="form-control inputStyleChange"
                      id="validationCustom02 "
                      autoComplete="off"

                      style={{ width: "100%" }}
                      disabledDate={disabledDate}
                    /> */}
                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.birthdate == "" && (
                        <span>Required Birth Date</span>
                      )}
                    </p> */}
                      </div>
                    </div>
                    <div class='row'>
                      <div class='col mt-3'>
                        <label for='validationCustom02' class='form-label'>
                          Blood Group
                        </label>
                        <select id='bloodgroup' value={createUserInfo[0].blood_group} name='blood_group' onChange={handleDropChanges} className='form-select inputStyleChange'>
                          <option value='' disabled selected>
                            Select Blood Group
                          </option>
                          <option value='A+'>A+</option>
                          <option value='A-'>A-</option>
                          <option value='B+'>B+</option>
                          <option value='B-'>B-</option>
                          <option value='AB+'>AB+</option>
                          <option value='AB-'>AB-</option>
                          <option value='O+'>O+</option>
                          <option value='O-'>O-</option>
                        </select>
                      </div>
                      <div class='col mt-3'>
                        <label for='residence' class='form-label'>
                          Area of residence
                        </label>
                        <input
                          type='text'
                          class='form-control inputStyleChange'
                          id='residence'
                          name='residence'
                          autoComplete='off'
                          onChange={e => handleDropChanges(e)}
                          value={createUserInfo[0].residence}
                          placeholder='Enter Patient Area of residence....'></input>
                      </div>
                      <div class='col mt-3'>
                        <label for='validationCustom02' class='form-label'>
                          Doctor referral
                        </label>

                        <select
                          class='form-control inputStyleChange'
                          id='validationCustom04 '
                          name='doctor_id'
                          autoComplete='off'
                          onChange={e => handleDocIdChange(e)}
                          value={!docref.includes(doctorid) ? '' : !docref.includes(createUserInfo[0].doctor_id) ? 'Others' : createUserInfo[0].doctor_id}
                          placeholder='Enter Doctor Referral....'>
                          <option value='' disabled selected>
                            Select Doctor referral
                          </option>
                          {docref.map(ele => {
                            return <option value={ele}>{ele}</option>;
                          })}
                        </select>
                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.doctor_id == "" && (
                        <span>Required Doctor Referral</span>
                      )}
                    </p> */}
                      </div>
                    </div>
                    <div className='row'>
                      {doctorid == 'Others' ? (
                        <div class='col-4 mt-3'>
                          <label for='validationCustom01' class='form-label'>
                            <span style={{color: 'red'}}>*</span>Others{' '}
                          </label>
                          <input
                            type='text'
                            class='form-control inputStyleChange'
                            id='validationCustom01'
                            name='first_name'
                            variant='standard'
                            autoComplete='off'
                            // value={createUserInfo.first_name}
                            // onKeyDown={(e) => {
                            //   if (e.target.value.length === 0 && e.which === 32) {
                            //     e.preventDefault();
                            //   }
                            // }}
                            onChange={e => {
                              setCreateUserInfo([
                                {
                                  ...createUserInfo[0],
                                  doctor_id: e.target.value
                                },
                                {
                                  ...createUserInfo[1],
                                  doctor_id: e.target.value
                                }
                              ]);
                            }}
                            placeholder='Enter Doctor referral....'></input>
                          <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo[0].first_name === '' && <span>Required Name</span>}</p>
                        </div>
                      ) : doctorid == 'Doctor' ? (
                        <>
                          <div className='col mt-3'>
                            <label for='validationCustom01' class='form-label'>
                              <span style={{color: 'red'}}>*</span>Doctor Name{' '}
                            </label>
                            <input
                              type='text'
                              class='form-control inputStyleChange'
                              id='validationCustom01'
                              name='doctor_name'
                              onChange={e => handleDropChanges(e)}
                              variant='standard'
                              autoComplete='off'
                              placeholder='Enter Doctor Name'></input>
                          </div>
                          <div className='col mt-3'>
                            <label for='validationCustom01' class='form-label'>
                              <span style={{color: 'red'}}>*</span>Doctor phonenumber{' '}
                            </label>
                            <input
                              type='number'
                              class='form-control inputStyleChange'
                              id='validationCustom01'
                              name='doctor_no'
                              variant='standard'
                              onChange={e => handleDropChanges(e)}
                              autoComplete='off'
                              placeholder='Enter Doctor Address'></input>
                          </div>
                          <div className='col mt-3'>
                            <label for='validationCustom01' class='form-label'>
                              <span style={{color: 'red'}}>*</span>Doctor Address{' '}
                            </label>
                            <textarea
                              type='text'
                              class='form-control inputStyleChange'
                              id='validationCustom01'
                              name='doctor_address'
                              onChange={e => handleDropChanges(e)}
                              variant='standard'
                              autoComplete='off'
                              placeholder='Enter Doctor Address'></textarea>
                          </div>
                        </>
                      ) : (
                        ''
                      )}
                    </div>

                    <button type='submit' class='btn btn-primary  create mt-3' onClick={e => handleCreatePatient1(e)} disabled={!alert}>
                      Go To Second Patient Record
                    </button>
                  </form>
                </div>
              </>
            )}

            {/* //*this is for the second couple */}

            {patient2 && (
              <>
                <div>
                  <span class={`btn btn-secondary btn-sm ${cplFill1 ? 'cplBtn' : ''}`} style={{}}>
                    Patient 1
                  </span>
                  <span class={`btn btn-secondary btn-sm ${cplFill2 ? 'cplBtn' : ''}`} style={{}}>
                    Patient 2
                  </span>
                </div>
                <div class='modal-body modelBodyChanges' style={{padding: '1rem', width: '920px'}}>
                  <form onSubmit={handleSubmit}>
                    <div class='row'>
                      <div class='col-3 title-dropdown'>
                        <label for='validationCustom01' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Title
                        </label>
                        <select
                          id='titles'
                          name='titles'
                          value={createUserInfo[1].titles}
                          disabled={createUserInfo[0].purpose !== 'Fertility'}
                          onChange={e => handleDropChanges2(e)}
                          className='form-select'>
                          <option value='' disabled selected>
                            Select a Title
                          </option>
                          <option value='Mr'>Mr</option>
                          <option value='Mrs'>Mrs</option>
                          <option value='Miss'>Miss</option>
                        </select>

                        {error && createUserInfo[1].titles == '' && (
                          <p style={{fontSize: '12px', color: 'red'}}>
                            <span>Required Title</span>
                          </p>
                        )}
                      </div>
                    </div>
                    <div class='row'>
                      <div class='col mt-3'>
                        <label for='validationCustom01' class='form-label'>
                          <span style={{color: 'red'}}>*</span>First Name
                        </label>
                        <input
                          type='text'
                          class='form-control inputStyleChange f_name'
                          id='validationCustom01'
                          name='first_name'
                          variant='standard'
                          style={{textTransform: 'uppercase'}}
                          autoComplete='off'
                          value={createUserInfo[1].first_name}
                          onKeyDown={e => {
                            if (e.target.value.length === 0 && e.which === 32) {
                              e.preventDefault();
                            }
                          }}
                          onChange={e => handleNameChange2(e)}
                          placeholder='Enter Patient First Name....'></input>
                        <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo[1].first_name === '' && <span>Required First Name</span>}</p>
                      </div>

                      <div class='col mt-3'>
                        <label for='validationCustom02' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Last Name
                        </label>
                        <input
                          type='text'
                          class='form-control inputStyleChange l_name'
                          id='validationCustom02 '
                          name='last_name'
                          style={{textTransform: 'uppercase'}}
                          autoComplete='off'
                          onChange={e => handleNameChange2(e)}
                          // onBlur={handleLastNameBlur}
                          onKeyDown={e => {
                            if (e.which == '32') {
                              e.preventDefault();
                            }
                          }}
                          value={createUserInfo[1].last_name}
                          placeholder='Enter Patient Last Name....'></input>
                        <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo[1].last_name == '' && <span>Required Last Name</span>}</p>
                      </div>
                    </div>
                    <div class='row'>
                      <div class='col mt-3'>
                        <label for='validationCustomUsername' class='form-label'>
                          Email
                        </label>
                        <div class='input-group has-validation'>
                          <span
                            class='input-group-text mailIcon inputStyleChange'
                            id='inputGroupPrepend'
                            style={{
                              borderRadius: '6px 0px 0px 6px'
                            }}>
                            @
                          </span>
                          <input
                            type='text'
                            class='form-control inputStyleChange'
                            id='email2'
                            aria-describedby='inputGroupPrepend'
                            autoComplete='off'
                            value={createUserInfo[1].email}
                            name='email'
                            onChange={e => handleEmailChange2(e)}
                            placeholder='Enter Patient Mail id....'
                            // onBlur={handleEmailBlur}
                          ></input>
                        </div>
                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.email == "" && (
                        <span>Required Email</span>
                      )}
                    </p> */}
                      </div>
                      <div class='col mt-3'>
                        <label for='validationCustom02' class='form-label'>
                          <span style={{color: 'red'}}>*</span>Whatsapp Mobile Number
                        </label>
                        <input
                          type='phonenumber'
                          class='form-control inputStyleChange'
                          id='validationCustom02 '
                          name='phonenumber'
                          autoComplete='off'
                          maxLength={10}
                          onChange={e => handleMobileChange2(e)}
                          // onBlur={handleMobileBlur}
                          onKeyDown={e => {
                            if (e.which == '32') {
                              e.preventDefault();
                            }
                          }}
                          value={createUserInfo[1].phonenumber}
                          placeholder='Enter Patient Mobile Number....'></input>
                        <p style={{fontSize: '12px', color: 'red'}}>{error && createUserInfo[1].phonenumber == '' && <span>Required Phone number</span>}</p>
                        {specificError.mobileSpecificError && (
                          <p style={{fontSize: '12px', color: 'red'}}>
                            <span>Enter Valid Phone Number.</span>
                          </p>
                        )}
                      </div>
                    </div>
                    <div class='row'>
                      <div className=' mt-4 col'>
                        <label for='validationCustom01' class='form-label'>
                          Gender
                        </label>
                        <select
                          id='titles'
                          name='gender'
                          value={createUserInfo[1].gender}
                          disabled={createUserInfo[0].purpose !== 'Fertility'}
                          onChange={handleDropChanges2}
                          className='form-select inputStyleChange'>
                          <option value='' disabled selected>
                            Select a Gender
                          </option>
                          <option value='Male'>Male</option>
                          <option value='Female'>Female</option>
                          <option value='Other'>Other</option>
                          <option value='Decline to State'>Decline to State</option>
                        </select>
                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.gender == "" && (
                        <span>Required Gender</span>
                      )}
                    </p> */}
                      </div>
                      <div class='col mt-4'>
                        <label for='dob2' class='form-label'>
                          Date of Birth
                        </label>
                        <input
                          type='date'
                          name='birthdate'
                          onChange={handleBirthDateChange2}
                          value={createUserInfo[1].birthdate || ''}
                          className='form-control inputStyleChange'
                          id='dob2'
                          autoComplete='off'
                          max={today.toISOString().split('T')[0]}
                        />
                      </div>
                      <div class='col mt-4'>
                        <label for='validationCustom02' class='form-label'>
                          Age
                        </label>
                        <input
                          type='number'
                          class='form-control inputStyleChange'
                          id='validationCustom02 '
                          name='age'
                          autoComplete='off'
                          maxLength={2}
                          onChange={e => handleAgeChange2(e)}
                          readOnly
                          // onBlur={handleMobileBlur}
                          onKeyDown={e => {
                            if (e.which == '32') {
                              e.preventDefault();
                            }
                          }}
                          value={createUserInfo[1].age}></input>

                        {/* <DatePicker
                      type="date"
                      name="birthdate"
                      format="dd MM yyyy"
                      onChange={handleBirthDateChanges}
                      class="form-control inputStyleChange"
                      id="validationCustom02 "
                      autoComplete="off"

                      style={{ width: "100%" }}
                      disabledDate={disabledDate}
                    /> */}
                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.birthdate == "" && (
                        <span>Required Birth Date</span>
                      )}
                    </p> */}
                      </div>
                    </div>
                    <div class='row'>
                      <div class='col mt-3'>
                        <label for='validationCustom02' class='form-label'>
                          Blood Group
                        </label>
                        <select
                          id='bloodgroup'
                          value={createUserInfo[1].blood_group}
                          name='blood_group'
                          onChange={handleDropChanges2}
                          className='form-select inputStyleChange'
                          style={{width: '300px'}}>
                          <option value='' disabled selected>
                            Select Blood Group
                          </option>
                          <option value='A+'>A+</option>
                          <option value='A-'>A-</option>
                          <option value='B+'>B+</option>
                          <option value='B-'>B-</option>
                          <option value='AB+'>AB+</option>
                          <option value='AB-'>AB-</option>
                          <option value='O+'>O+</option>
                          <option value='O-'>O-</option>
                        </select>
                        {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && createUserInfo.blood_group == "" && (
                        <span>Blood Group Required.</span>
                      )}
                    </p> */}
                      </div>
                      <div class='col mt-3'>
                        <label for='residence' class='form-label'>
                          Area of residence
                        </label>
                        <input
                          type='text'
                          class='form-control inputStyleChange'
                          id='residence'
                          name='residence'
                          autoComplete='off'
                          onChange={e => handleDropChanges2(e)}
                          value={createUserInfo[1].residence}
                          placeholder='Enter Patient Area of residence....'></input>
                      </div>
                    </div>

                    <button type='submit' class='btn btn-primary  create mt-3' onClick={e => handleCreatePatient2(e)} disabled={!alert}>
                      Create Patient Record
                    </button>
                  </form>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AddPatientCouple_form;
